<div class="modal-header">
  <h5 class="modal-title">Update Subscription</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
</div>
<div class="modal-body">

  <div class="card mb-3">
    <div class="card-body">
      <div class="d-flex">
        <h5>Current Subscription</h5>
        <div class="my-auto ms-auto">
          @switch (selectedSubscription?.organizationStatus) {
          @case ("ACTIVE") {
          <span class="badge text-bg-success">Active</span>
          }
          @case ("TRIAL") {
          <span class="badge text-bg-warning">Trial</span>
          }
          @case ("EXPIRING") {
          <span class="badge text-bg-warning">Expiring</span>
          }
          @case ("DELINQUENT") {
          <span class="badge text-bg-danger">Delinquent</span>
          }
          @case ("INACTIVE") {
          <span class="badge text-bg-danger">Inactive</span>
          }
          }
        </div>
      </div>
      <div class="mt-2">
        <div class="d-flex">
          <strong class="fw-medium">Name</strong>
          <p class="mb-0 ms-auto">{{ selectedSubscription?.name }}</p>
        </div>
        <div class="d-flex">
          <strong class="fw-medium">Price</strong>
          <p class="mb-0 ms-auto">${{ selectedSubscription?.price }}</p>
        </div>
        <div class="d-flex">
          <strong class="fw-medium">Renewal Date</strong>
          <p class="mb-0 ms-auto">{{ selectedSubscription?.renewalDate | formatDateTime: true }}</p>
        </div>
      </div>
      @if (selectedSubscription?.organizationStatus == "ACTIVE" || selectedSubscription?.organizationStatus == "TRIAL" || selectedSubscription?.organizationStatus == "DELINQUENT") {
      <button class="btn btn-danger w-100 mt-2" (click)="openCancelSubscriptionModal();">Cancel</button>
      }
    </div>
  </div>

  <div *ngIf="selectedSubscription?.scheduledChange && selectedSubscription?.scheduledChange?.newSubscriptionId" class="mt-3">
    <div class="card">
      <div class="card-body">
        <h5>Subscription Change</h5>
        <div class="mt-2">
          <div class="d-flex">
            <strong class="fw-medium">Name</strong>
            <p class="mb-0 ms-auto">{{ getScheduleSubscriptionName(selectedSubscription?.scheduledChange?.newSubscriptionId) }}</p>
          </div>
          <div class="d-flex">
            <strong class="fw-medium">Scheduled On</strong>
            <p class="mb-0 ms-auto">{{ selectedSubscription?.scheduledChange.scheduleDate | formatDateTime: true }}</p>
          </div>
        </div>
        <button class="btn btn-danger w-100 mt-2" (click)="cancelOrganizationSubscriptionChange();">Cancel</button>
      </div>
    </div>
  </div>

  <form *ngIf="!selectedSubscription?.scheduledChange" [formGroup]="subscriptionForm" class="mt-3">
    <ul class="list-group">
      <li *ngFor="let subscription of subscriptions" class="list-group-item">
        <input [id]="'subscription-' + subscription.id" class="form-check-input me-2 mb-2" type="radio" name="subscriptionRadio" [value]="subscription.id" [checked]="subscription.id === selectedSubscription?.subscriptionId" (change)="selectSubscription(subscription)" />
        <label [for]="'subscription-' + subscription.id" class="form-check-label">
          <div class="d-flex flex-row justify-content-between">
            <strong class="fw-bold align-self-center">{{ subscription.name }}</strong>
            <div class="ms-auto my-auto fs-4">
              <span class="fw-normal">${{ subscription?.price }}</span>
              <span *ngIf="subscription?.frequency == 'MONTHLY'" class="fw-normal" style="font-size: 16px;">/month</span>
              <span *ngIf="subscription?.frequency == 'ANNUALLY'" class="fw-normal" style="font-size: 16px;">/year</span>
            </div>
          </div>
        </label>
      </li>
    </ul>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="updateSubscription()" [disabled]="!newSubscription">Save</button>
  <button type="button" class="btn btn-secondary" (click)="modal.dismiss();">Cancel</button>
</div>